var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chartist',{staticClass:"v-card--material-chart",attrs:{"data":_vm.data,"event-handlers":_vm.eventHandlers,"options":_vm.options,"ratio":_vm.ratio,"responsive-options":_vm.responsiveOptions,"type":_vm.type}})}
var staticRenderFns = []

export { render, staticRenderFns }